import { styled, Stack, TextField, Typography, Box } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(1),
  overflow: 'hidden',
  gap: theme.spacing(1),
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    minHeight: '100dvh',
  },
}));

export const StyledFormulaContainer = styled(Stack)(({ theme }) => ({
  overflowY: 'scroll',
  whiteSpace: 'nowrap',
  gap: theme.spacing(1),
  flex: 1,
  scrollbarWidth: 'none',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    minHeight: theme.spacing(20),
    color: theme.palette.grey[900],
  },
  '& .MuiOutlinedInput-root': {
    background: theme.palette.grey[50],
  },
}));

export const StyledHintTextWrapper = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const StyledCharacterCount = styled(Typography)(({ theme }) => ({
  textAlign: 'end',
  color: theme.palette.grey[400],
  fontSize: 12,
}));

export const StyledInstrumentalLabel = styled(StyledCharacterCount)({
  textAlign: 'right',
});

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
